import SurveyResponsesTableCard from './SurveyResponsesTableCard';

export default SurveyResponsesTableCard;
